/**
 * Generic WCAG contrast ratio utilities.
 */

function hexToRgb(hex: string): [number, number, number] {
  const clean = hex.replace("#", "");
  return [
    parseInt(clean.slice(0, 2), 16),
    parseInt(clean.slice(2, 4), 16),
    parseInt(clean.slice(4, 6), 16)
  ];
}

function calculateLuminance(rgb: [number, number, number]): number {
  const [r, g, b] = rgb.map(x => {
    const c = x / 255;
    return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
  });
  return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}

export function contrastRatio(hex1: string, hex2: string): number {
  const lum1 = calculateLuminance(hexToRgb(hex1));
  const lum2 = calculateLuminance(hexToRgb(hex2));
  const lighter = Math.max(lum1, lum2);
  const darker = Math.min(lum1, lum2);
  return (lighter + 0.05) / (darker + 0.05);
}

export function bestContrastColor(
  background: string,
  lightOption: string,
  darkOption: string
): string {
  return contrastRatio(background, lightOption) > contrastRatio(background, darkOption)
    ? lightOption
    : darkOption;
}
